import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import MainButton from '../common/util/input/MainButton'
import { sleep } from '../helpers/FormatLinks'
import { getBoostAction } from '../helpers/WaxApi'
import LoadingIndicator from '../loadingindicator/LoadingIndicator'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'

function BulkTransferPopup(props) {
    const assets = props['assets']

    const { t } = useTranslation('common')

    const ual = props['ual'] ? props['ual'] : { activeUser: null }
    const activeUser = ual['activeUser']

    const callBack = props['callBack']

    const userName = activeUser ? activeUser['accountName'] : null
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()
    const closeCallBack = props['closeCallBack']
    const [errors, setErrors] = useState({})
    const [transactions, setTransactions] = useState({})

    const addError = (assetId, e) => {
        errors[assetId] = e
        setErrors(errors)
    }

    const addTransaction = (assetId, tx) => {
        transactions[assetId] = tx
        setTransactions(transactions)
    }

    const maxActions = 10

    const [currentDisplayAction, setCurrentDisplayAction] = useState(0)

    const transfer = async () => {
        setIsLoading(true)

        let currentAction = 0

        const atomicBurns = []
        const simpleBurns = []

        for (const assetId of Object.keys(assets)) {
            if (assets[assetId].standard === 'atomicassets') {
                atomicBurns.push(assets[assetId].aAssetId)
            } else if (assets[assetId].standard === 'simpleassets') {
                simpleBurns.push(assets[assetId].assetId)
            }
        }

        const actions = [getBoostAction(activeUser)]

        if (simpleBurns.length > 0) {
            actions.push({
                account: 'simpleassets',
                name: 'burn',
                authorization: [
                    {
                        actor: userName,
                        permission: activeUser['requestPermission'],
                    },
                ],
                data: {
                    owner: userName,
                    assetids: simpleBurns,
                    memo: 'NFTHive.io Bulk Burn',
                },
            })

            try {
                const result = await activeUser.signTransaction(
                    {
                        actions: actions,
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )
                simpleBurns
                    .sort((a, b) => parseInt(a) - parseInt(b))
                    .map((assetId) =>
                        addTransaction(assetId, result['transactionId']),
                    )
            } catch (e) {
                Object.keys(assets)
                    .filter((asset) =>
                        simpleBurns.includes(assets[asset].assetId),
                    )
                    .map((asset) => addError(asset, e.message))
                console.log(e)
                setError(e.message)
            }
        }

        if (atomicBurns.length > 0 && simpleBurns.length > 0) {
            sleep(1000)
        }

        while (currentAction < atomicBurns.length / maxActions) {
            const start = currentAction * maxActions
            const end = start + maxActions
            const actions = [getBoostAction(activeUser)]

            const currentBurns = atomicBurns
                .sort((a, b) => parseInt(a) - parseInt(b))
                .slice(start, end)

            currentBurns.map((assetId) => {
                actions.push({
                    account: 'atomicassets',
                    name: 'burnasset',
                    authorization: [
                        {
                            actor: userName,
                            permission: activeUser['requestPermission'],
                        },
                    ],
                    data: {
                        asset_owner: userName,
                        asset_id: assetId,
                    },
                })
            })

            try {
                const result = await activeUser.signTransaction(
                    {
                        actions: actions,
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )
                Object.keys(assets)
                    .filter((assetId) =>
                        currentBurns.includes(assets[assetId].aAssetId),
                    )
                    .map((assetId) =>
                        addTransaction(assetId, result['transactionId']),
                    )
            } catch (e) {
                Object.keys(assets)
                    .filter((assetId) =>
                        currentBurns.includes(assets[assetId].aAssetId),
                    )
                    .map((asset) => addError(asset, e.message))
                console.log(e)
                setError(e.message)
            } finally {
                currentAction += 1
                setCurrentDisplayAction(currentAction)
            }

            if (currentAction < atomicBurns.length / maxActions) {
                sleep(1000)
            }
        }

        setIsLoading(false)
        callBack({
            transferred: true,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    let transferInfo = t('asset.burn')

    const transferField = (
        <MainButton className="PopupSellButton" onClick={transfer}>
            {transferInfo}
        </MainButton>
    )

    const cancel = () => {
        callBack({
            transferred: false,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    const name = t('search.bulk_burn')

    return (
        <Popup title={name} cancel={cancel}>
            <div className="mx-auto text-xl font-bold mb-4">
                {t('popups.are_you_sure_you_want_to_burn_assets', {
                    number: Object.keys(assets).length,
                })}
            </div>
            {error ? <ErrorMessage error={error} /> : ''}
            <div className="Buttons">
                <MainButton className="PopupCancelButton" onClick={cancel}>
                    {t('asset.cancel')}
                </MainButton>
                {transferField}
            </div>
            {isLoading ? (
                <div className="Overlay">
                    <LoadingIndicator
                        text={`Loading Transactions - Adding wait time to avoid Rate Limiting - Tx ${currentDisplayAction} / ${Math.ceil(
                            Object.keys(assets).length / maxActions,
                        )}`}
                    />
                </div>
            ) : (
                ''
            )}
        </Popup>
    )
}

export default BulkTransferPopup
